import types from "./types";
import { saveToStorage } from "@/helpers/localStorage";

export default {
  [types.SET_APP_SCHEME]: function(state, scheme) {
    state.scheme = scheme;
    saveToStorage("colorScheme", scheme);

    const styleEl = getOrCreateElement();
    styleEl.innerHTML = toStyleString(scheme);
  },
  updateLogo(state, logo) {
    state.logo = logo;
  }
};

function getOrCreateElement() {
  let styleEl = document.querySelector("#root-styles");

  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = "root-styles";
    styleEl.setAttribute("type", "text/css");
    document.head.appendChild(styleEl);
  }

  return styleEl;
}

function toStyleString(scheme = {}) {
  return Object.entries(scheme).reduce((acc, [key, value], i, arr) => {
    if (i === 0) {
      acc += ":root {\n";
    }

    acc += "--" + key + ":" + value + ";\n";

    if (i === arr.length - 1) {
      acc += "}";
    }

    return acc;
  }, "");
}
